import { render, staticRenderFns } from "./TaraWorkforceCostCard.vue?vue&type=template&id=4db35538&scoped=true"
import script from "./TaraWorkforceCostCard.vue?vue&type=script&lang=js"
export * from "./TaraWorkforceCostCard.vue?vue&type=script&lang=js"
import style0 from "./TaraWorkforceCostCard.vue?vue&type=style&index=0&id=4db35538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db35538",
  null
  
)

export default component.exports